( function( $ ) {

	// get text from inside set of elements
	// returns an array of strings
	var getTitlesList = function( el ) {
		var $th = $( el ).find( 'thead th' );
		var list = [];

		for ( var i = 0; i < $th.length; i++ ) {
			var text = ( $th.eq( i ).text() ).trim();
			list.push( text );
		}

		return list;
	};

	// pass in a responsiveTable object and add responsive titles to its table columns
	var addTitles = function( obj ) {
		obj.$rows.each( function( i ){
			$tds = $( this ).children();

			for ( var i = 0; i < $tds.length; i++ ) {
				var $td = $tds.eq( i );

				if ( $td.html() !== '' ) {
					$tds.eq( i ).attr( 'data-th', obj.titles[i] );
				}
			}
		} );
	};

	var responsiveTable = function( el ) {
		var self = this;
		this.el = el;

		this.update();
	};

	// expose this as a public function so it can be called on the object
	// if the table content is updated after it is first initialized.
	responsiveTable.prototype.update = function() {
		this.titles = getTitlesList( this.el );
		this.$rows = $( this.el ).find( 'tbody tr' );

		addTitles( this );
	};

	var constructTables = function( el ) {
		var $els = $( el );
		var list = [];

		// loop through each selected element and create a new responsive table object from it.
		for ( var i = 0; i < $els.length; i++ ) {
			var t = new responsiveTable( $els[i] );
			list.push( t );
		}

		// return list of responsive table objects for chaining
		return list;
	};

	// expose constructTables function to global scope for use
	window.responsiveTables = constructTables;

} )( window.jQuery );
